(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mymazn-customer-gallery"] && !Shopify.designMode) return;
  try {
    
  function initializeMymaznGalleries() {
    document.querySelectorAll('.mz-gallery:not([data-gallery-ready])').forEach((gallery) => {
      gallery.dataset.galleryReady = 'true';
      const track = gallery.querySelector('.mz-gallery-track');
      const dialog = gallery.querySelector('dialog');
      const image = dialog.querySelector('[data-gallery-full]');
      const controls = gallery.querySelector('.mz-gallery-controls');
      const buttons = [...controls.querySelectorAll('button')];
      const update = () => {
        const overflow = track.scrollWidth - track.clientWidth;
        controls.hidden = overflow < 2;
        buttons[0].disabled = track.scrollLeft < 2;
        buttons[1].disabled = track.scrollLeft >= overflow - 2;
      };
      track.addEventListener('scroll', update, { passive: true });
      new ResizeObserver(update).observe(track);
      buttons.forEach((button) => button.addEventListener('click', () => {
        const distance = track.firstElementChild.getBoundingClientRect().width + 16;
        track.scrollBy({ left: Number(button.dataset.galleryDirection) * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }));
      gallery.querySelectorAll('[data-gallery-image]').forEach((button) => button.addEventListener('click', () => {
        image.src = button.dataset.galleryImage;
        image.alt = button.dataset.galleryAlt;
        dialog.showModal();
      }));
      dialog.querySelector('[data-gallery-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => { image.removeAttribute('src'); });
      update();
    });
  }
  initializeMymaznGalleries();
  document.addEventListener('shopify:section:load', initializeMymaznGalleries);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mymazn-expandable-series-detail"]) return;
  try {
    
function initializeExpandableDetails(){
  document.querySelectorAll('[data-expandable-section]:not([data-expandable-ready])').forEach(section=>{
    section.dataset.expandableReady='true';
    const active=section.querySelector('[data-expandable-active]');
    const show=id=>{
      if(!id||active.firstElementChild?.dataset.expandableVariant===String(id))return;
      const template=section.querySelector('template[data-expandable-template="'+String(id)+'"]');
      if(!template)return;
      active.replaceChildren(template.content.cloneNode(true));
    };
    document.addEventListener('change',event=>{
      const target=event.target;
      if(!(target instanceof HTMLElement)||!target.closest('variant-picker')||target.closest('product-card,quick-add-dialog'))return;
      if(target.closest('variant-picker').dataset.productId!==section.dataset.expandableProduct)return;
      const option=target instanceof HTMLSelectElement?target.selectedOptions[0]:target;
      if(option?.dataset.variantId)show(option.dataset.variantId);
    });
    window.addEventListener('popstate',()=>show(new URL(location.href).searchParams.get('variant')||section.dataset.expandableDefault));
    section.addEventListener('shopify:block:select',event=>show(event.target.closest('[data-expandable-variant]')?.dataset.expandableVariant));
  });
}
initializeExpandableDetails();
document.addEventListener('shopify:section:load',initializeExpandableDetails);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mymazn-product-story"] && !Shopify.designMode) return;
  try {
    
function initializeMymaznStories(){
  document.querySelectorAll('.mz-product-story:not([data-story-ready])').forEach(section=>{
    section.dataset.storyReady='true';
    const show=id=>{
      const template=section.querySelector('template[data-story-template="'+String(id)+'"]');
      const active=section.querySelector('.mz-story-active');
      if(!template){active.replaceChildren();section.hidden=true;return;}
      if(active.firstElementChild?.dataset.storyVariant===String(id)){section.hidden=false;return;}
      active.replaceChildren(template.content.cloneNode(true));
      section.hidden=false;
    };
    const select=event=>{
      const target=event.target;
      if(!(target instanceof HTMLElement)||!target.closest('variant-picker')||target.closest('product-card,quick-add-dialog'))return;
      const option=target instanceof HTMLSelectElement?target.selectedOptions[0]:target;
      if(option?.dataset.variantId)show(option.dataset.variantId);
    };
    document.addEventListener('change',select);
    window.addEventListener('popstate',()=>show(new URL(location.href).searchParams.get('variant')||document.querySelector('.product-information form[action*="/cart/add"] [name="id"]')?.value));
    section.addEventListener('shopify:block:select',event=>{const id=event.target.closest('[data-story-variant]')?.dataset.storyVariant;if(id)show(id);});
  });
}
initializeMymaznStories();
document.addEventListener('shopify:section:load',initializeMymaznStories);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mymazn-public-header"]) return;
  try {
    
document.addEventListener('keydown', (event) => {
  if (event.key === 'Escape') document.querySelectorAll('.mz-series-header details[open]').forEach((menu) => { menu.open = false; menu.querySelector('summary').focus(); });
});
document.addEventListener('click', (event) => {
  document.querySelectorAll('.mz-series-header details[open]').forEach((menu) => { if (!menu.contains(event.target)) menu.open = false; });
});

  } catch(e) { console.error(e); }
})();
})();
